/**
 * Shared, strict sub-schema for the optional `_meta` provenance block that may
 * accompany any data-point answer as a sibling of `value`.
 *
 * It stays strict (`additionalProperties: false`, `source` + `syncedAt`
 * required) so a malformed `_meta` is rejected. The permitted keys mirror what
 * the platform's provenance stamper persists on AI/API-synced answers
 * (`modules/companies` PatchTemplateAnswersService): `source`, `syncedAt`,
 * `sourceAuditId`, plus `generatedBy` / `auditType` / `externalSource` (each
 * nullable). Callers strip `_meta` before validating, but a path that does not
 * must still accept a stamped answer rather than reject the whole template
 * (DELTA-2557). `syncedAt` is an ISO-8601 date-time (validated via ajv-formats).
 */
export const META_SCHEMA = {
  type: 'object',
  additionalProperties: false,
  required: ['source', 'syncedAt'],
  properties: {
    source: {type: 'string'},
    syncedAt: {type: 'string', format: 'date-time'},
    sourceAuditId: {type: 'string'},
    generatedBy: {type: ['string', 'null']},
    auditType: {type: ['string', 'null']},
    externalSource: {type: ['string', 'null']},
  },
}
